
export const setTypes = (state, types) => {
    state.types = types
    state.loading = false
}

export const setCurrentType = (state, type) => {
    state.currentType = type
    state.loading = false
}

export const setLoading = (state, loading) => {
    state.loading = loading
}
